import type { ReferencedEntry } from 'contentful';

import type { ContentType } from 'api/contentful/contentTypes.cloverdotcom';
import { getContentTypeLink } from './EntryUtil';

// Util functions for easier code coverage

export function getContentType(entry?: ReferencedEntry<any>): ContentType | undefined {
  const contentTypeLink = getContentTypeLink(entry);

  return contentTypeLink && (contentTypeLink.id as ContentType);
}
